import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';

export default class NavBar extends AContainer {
  constructor(scene) {
    super(scene);

    this.createNav();
    this.tweenInNav();
  }

  createNav() {
    this.bg = this.scene.addImage(0, 0, "Nav_Bar", this.scene.defaultAtlas, this);

    let txt;
    if (gameData.currentScene === "Game") {
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('instructions' + gameData.level);
    } else {
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('navbar_header');
    }

    this.instructions = this.scene.addText(0, -10, 24, "0xFFFFFF", this.scene.defaultFont, txt, this, true);
    this.instructions.setWordWrapWidth(625);
    this.instructions.setInteractive();
    this.instructions.on("pointerdown", () => {
      if (gameData.currentScene === "Game") {
        this.scene.playSound(gameData.levelSound, 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      } else if (gameData.currentScene === "Customize") {
        this.scene.playSound("make_your_own_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
      }
    });

    this.home = this.scene.addButton(this.bg.width / 2 - 75, -10, "Btn_Menu", {}, () => { this.scene.pauseGame(); }, this);
    this.home.setEnabled(false);

    this.setPosition(this.scene.mid.x, -100);
  }

  createLevel() {
    this.levelBg = this.scene.addImage(-this.bg.width / 2 + 75, -10, "Progress_Area", this.scene.defaultAtlas, this);
    this.level = this.scene.addText(this.levelBg.x - 15, this.levelBg.y, 20, "0xFFFFFF", this.scene.defaultFont, gameData.level, this, true);
    this.levelMax = this.scene.addText(this.levelBg.x + 11, this.levelBg.y, 20, "0xFFFFFF", this.scene.defaultFont, "/10", this, true);
  }

  tweenOutInstructions() {
    if (gameData.level === 0) {
      this.scene.addTween(this.instructions, 500, { alpha: 0 }, Phaser.Math.Easing.None,
        () => { this.updateLevel(); });
    } else {
      this.scene.addTween(this.instructions, 500, { alpha: 0 }, Phaser.Math.Easing.None);
    }
    this.scene.addTween(this.instructions, 500, { alpha: 0 }, Phaser.Math.Easing.None);
  }

  updateLevel() {
    this.instructions.text = ABCyaPhaser.Localization.instance.getLocalizedString('instructions' + gameData.level);

    this.scene.addTween(this.instructions, 500, { alpha: 1 }, Phaser.Math.Easing.None);
  }

  toggleMute() {
    //console.log(gameData.gameMuted);
    this.scene.playSound("click");

    if (!gameData.gameMuted) {
      //console.log("muting");
      //this.scene.sound.setVolume(0);
      if (gameData.jingle) gameData.jingle.pause();

      this.mute.visible = false;
      this.soundBtn.visible = true;

      this.mute.setEnabled(false);
      this.soundBtn.setEnabled(true);

      gameData.gameMuted = true;
    } else {
      //console.log("unmuting");
      //this.scene.sound.setVolume(1);
      if (gameData.jingle) gameData.jingle.resume();

      this.mute.visible = true;
      this.soundBtn.visible = false;

      this.soundBtn.setEnabled(false);
      this.mute.setEnabled(true);

      gameData.gameMuted = false;
    }
  }

  tweenInNav() {
    //this.scene.playSound("theme_exit");
    if (gameData.currentScene === "Customize") {
      this.scene.playSound("make_your_own_fb", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    if (gameData.level === 0) {
      //console.log("tweening in");
      this.scene.addTween(this, 1000, { y: this.bg.height / 2 }, Phaser.Math.Easing.Quadratic.Out,
        () => {
          //gameData.level++;
          this.home.setEnabled(true);
        });
    } else {
      this.y = this.bg.height / 2;
      //if(gameData.currentScene === "Game") this.updateLevel();
      this.home.setEnabled(true);
    }
  }

  tweenOutNav() {
    //this.scene.playSound("theme_exit");
    this.scene.addTween(this, 1000, { y: -this.bg.height / 2 }, Phaser.Math.Easing.Quadratic.Out);
  }

  disableNav() {
    //console.log("disabling buttons");
    if (this.home) this.home.setEnabled(false);
    if (this.mute) this.mute.setEnabled(false);
    if (this.soundBtn) this.soundBtn.setEnabled(false);
  }

  enableNav() {
    //console.log("enabling buttons");
    this.home.setEnabled(true);
    if (this.mute) this.mute.setEnabled(true);
    if (this.soundBtn) this.soundBtn.setEnabled(true);
  }

  cleanUp() {
    //console.log("cleaning UP");
    this.scene.playSound("click");

    this.disableNav();

    this.home.destroy();
    this.instructions.destroy();
    this.bg.destroy();

    if (this.mute) {
      this.mute.destroy();
      this.soundBtn.destroy();
    }

    // if(gameData.currentScene === "Game"){
    //     // this.graphics.clear();

    //     // this.levelBg.destroy();
    //     // this.level.destroy();
    //     // this.levelMax.destroy();

    //     if(scene === "Intro") this.scene.cleanUp(scene);
    // }
    // else if(gameData.currentScene === "Customize"){
    //     this.scene.cleanUp("Intro");
    // }
  }
}